import styled from 'styled-components';
import { colors, toRgba, mixins } from '@/styles';

export const Column = styled.div<{ $selected: boolean }>`
  border: 2px solid transparent;
  border-radius: 5px;
  margin-bottom: 10px;
`;

export const ColumnHeading = styled.div<{}>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  /* font-weight: 600; */
  padding: 5px;
`;

export const ColumnBody = styled.div<{
  $selected: boolean;
  $isImage?: boolean;
  $isCode?: boolean;
  $isMarkdown?: boolean;
  $editable?: boolean;
}>`
  /* display: inline-flex; */
  /* min-width: 250px; */
  margin-top: 2px;

  padding: ${({ $editable, $isCode }) => ($editable ? ($isCode ? '5px' : '0px') : '10px')};
  border-radius: 5px;
  border: 1px solid transparent;
  overflow-y: auto;

  /* box-shadow: inset 1px 1px 4px 0px rgba(0, 0, 0, 0.2); */
  background: ${({ $selected, $editable, $isCode, $isMarkdown }) =>
    $selected || $editable || $isCode || $isMarkdown ? colors.primary.white : 'transparent'};
  ${({ $isImage }) => $isImage && mixins.checkedImageBackground};
  border-color: ${({ $selected }) => ($selected ? colors.semantic.information.dark : colors.secondary.lightGray3)};

  & > div {
    margin-left: ${({ $isCode }) => ($isCode ? '-10px' : '0px')};
  }
`;
